import React, { useState } from "react";

const ToolRow = ({ tool, onToggleEnabled, onDelete, onDeleteConfirm }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDeleteClick = () => {
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = () => {
    onDeleteConfirm(tool.id);
    setShowDeleteConfirm(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  return (
    <div className="manage-tools-row">
      <div className="manage-tools-info">
        <h3 className="manage-tools-name">{tool.name}</h3>
        <p className="manage-tools-category">{tool.category}</p>
        <p className="manage-tools-tool-description">{tool.description}</p>
        {tool.is_custom && (
          <p className="manage-tools-command">
            Command: <code>{tool.command}</code>
          </p>
        )}
      </div>

      <div className="manage-tools-badges">
        {tool.is_custom ? (
          <span className="manage-tools-custom-badge">Custom</span>
        ) : (
          <span className="manage-tools-builtin-badge">Built-in</span>
        )}
        {!tool.enabled && (
          <span className="manage-tools-disabled-badge">Disabled</span>
        )}
      </div>

      <div className="manage-tools-actions">
        <label className="manage-tools-toggle-switch">
          <input
            type="checkbox"
            checked={tool.enabled || false}
            onChange={() => onToggleEnabled(tool.id, !tool.enabled)}
          />
          <span className="manage-tools-switch"></span>
        </label>

        {tool.is_custom && (
          <>
            {showDeleteConfirm ? (
              <div className="manage-tools-delete-confirm">
                <p>Delete "{tool.name}"?</p>
                <button type="button" className="manage-tools-confirm-button" onClick={handleConfirmDelete}>
                  Confirm
                </button>
                <button type="button" className="manage-tools-cancel-button" onClick={handleCancelDelete}>
                  Cancel
                </button>
              </div>
            ) : (
              <button
                type="button"
                className="manage-tools-delete-button"
                onClick={handleDeleteClick}
                title="Delete custom tool"
              >
                🗑️ Delete
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ToolRow;
